// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"260":"57eb7e02632431a0","729":"5221a81e8563251f"}[chunkId] + ".js";
};